import { platformsWidgetblock } from './platformsWidgetblock';
export const getWidgetblockBatcher = async (queries) => {
    const widgetblockIds = queries.reduce((widgetblockIds, { widgetblockId }) => {
        return [...widgetblockIds, widgetblockId];
    }, []);
    const { stage, metjwt, headers } = queries[0];
    const getWidgetblocksResponse = await platformsWidgetblock.http.get({
        widgetblockIds,
        stage,
        metjwt,
        headers,
    });
    return widgetblockIds.map((widgetblockId) => {
        return getWidgetblocksResponse.data.find((w) => w.id === widgetblockId);
    });
};
